(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@didi/omega-tracker"));
	else if(typeof define === 'function' && define.amd)
		define(["@didi/omega-tracker"], factory);
	else if(typeof exports === 'object')
		exports["index"] = factory(require("@didi/omega-tracker"));
	else
		root["index"] = factory(root["Omega"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__9613__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "163f":
/***/ (function(module) {

module.exports = JSON.parse("{\"list\":\"[\\\"MX\\\",\\\"BR\\\",\\\"JP\\\",\\\"CR\\\",\\\"CO\\\",\\\"DO\\\"]\",\"MX\":\"{\\\"countryCode\\\":\\\"MX\\\",\\\"countryName\\\":\\\"墨西哥\\\",\\\"countryId\\\":484,\\\"callingCode\\\":\\\"+52\\\",\\\"defaultLang\\\":\\\"es-MX\\\",\\\"defaultLocale\\\":\\\"es-MX\\\",\\\"realLocale\\\":\\\"es-MX\\\",\\\"locales\\\":[\\\"es-MX\\\"],\\\"currency\\\":[\\\"MXN\\\"],\\\"timezones\\\":[\\\"America/Mexico_City\\\"],\\\"cityList\\\":[52120200,52131100,52100200,52250400,152190500,152140500,52270100,52240400,52300900,52320100,52180200,52260200,52260100,52250100,52080800,52160400,52210400,52020200,52020300,52200100,52170200,52020100,52151600,52110400,52110300,52110200,52110500,52220400,52310300,52050400,52050500,52190500,52140500,52080200,52090100,152090100,52159900,52010100,52250300,52230100,155000116,181270100,52140900,52030300,52030200,52110600,52280300,52060200,52060100,52160800,52160900,52110800,52260400,52301000,52280400,52050200,52280500,52280200,52280100,52300200,52040100,52260900,52071100,52210600,52070900,52040200,52230200,52290400,52301300,52301200,52300600,52060300,52302300,52220200,52260300,52070200,52070800,52120500,52230300,52080400,52290100]}\",\"BR\":\"{\\\"countryCode\\\":\\\"BR\\\",\\\"countryName\\\":\\\"巴西\\\",\\\"countryId\\\":76,\\\"callingCode\\\":\\\"+55\\\",\\\"defaultLang\\\":\\\"pt-BR\\\",\\\"defaultLocale\\\":\\\"pt-BR\\\",\\\"realLocale\\\":\\\"pt-BR\\\",\\\"locales\\\":[\\\"pt-BR\\\"],\\\"currency\\\":[\\\"BRL\\\"],\\\"timezones\\\":[\\\"America/Sao_Paulo\\\"],\\\"cityList\\\":[155000116,55000257,55000213,55000243,55000210,55000481,55000533,55000353,55000331,55000450,55000161,55000199,55000118,55000133,55000416,55000515,55359900,55000097,55000105,55000140,55000106,55000089,55000116,55000041,55000049,55000063,55000231,55000287,55000182,55000185,55000215,55000326,55000439,55000392,55000409,55000465,55000233,55000103,55000165,55000031,55000177,55000178,55000511,55000207,55000025,55000218,55000272,55000509,55000027,55000188,55000179,55000204,55000206,55000189,55000230,55000292,55000135,55000184,55000516,55000430,55000236,55000285,55000167,55000150,55000164,55000160,55000232,55000201,55000157,55000121,55000521,55000034,55000172,55000198,55000024,55000158,55000005,55000068,55000238,55000149,55000045,55000391,55000208,55000195,55000155,55000498,55000263,55000192,55000300,55000550,55000094,55000146,55000126,55000382,55000162,55000506,55000432,55000012,55000418,55000548,55000258,55000212,55000065,55000267,55000387,55000397,55000082,55000335,55000314,55000072,55000463,55000200,55000092,55000148,55000216,55000294,55000197,55000147,55000260,55000493,55000424,55000503,55000163,55000482,55000459,55000468,55000340,55000484,55000227,55000317,55000374,55000174,55000017,55000364,55000229,55000426,55000480,55000433,155000416,155000481,155000257,155000515,155000243,55000071,55000211,55000322,55000043,55000437,55000276,55000534,55000350,55000363,55000365,55000187,55000283,55000288,55000296,55000492,55000502,55000505,55000108,55000169,55000247,55000250,55000059,55000303,55000023,55000039,55000242,55000004,55000006,55000235,55000441,55000452,55000359,55000327,55000307,55000336,55000181,55000203,55000214,55000404,55000412,55000422,55000239,55000362]}\",\"JP\":\"{\\\"countryCode\\\":\\\"JP\\\",\\\"countryName\\\":\\\"日本\\\",\\\"countryId\\\":392,\\\"callingCode\\\":\\\"+81\\\",\\\"defaultLang\\\":\\\"ja-JP\\\",\\\"defaultLocale\\\":\\\"ja-JP\\\",\\\"realLocale\\\":\\\"ja-JP\\\",\\\"locales\\\":[\\\"ja-JP\\\"],\\\"currency\\\":[\\\"JPY\\\"],\\\"timezones\\\":[\\\"Asia/Tokyo\\\"],\\\"cityList\\\":[181270100,81400100,81139900,81270100,81280100,81340100,81260100,81230100,81010100,81470100,81430100,81420100,81460100,81410100,81440100,81350100,81290100,81300100,81250100,81040100,81110100,81120100,81220100,81150100]}\",\"CR\":\"{\\\"countryCode\\\":\\\"CR\\\",\\\"countryName\\\":\\\"哥斯达黎加\\\",\\\"countryId\\\":506,\\\"callingCode\\\":\\\"+506\\\",\\\"defaultLang\\\":\\\"es-419\\\",\\\"defaultLocale\\\":\\\"es-CR\\\",\\\"realLocale\\\":\\\"es-CR\\\",\\\"locales\\\":[\\\"es-CR\\\"],\\\"currency\\\":[\\\"CRC\\\"],\\\"timezones\\\":[\\\"America/Costa_Rica\\\"],\\\"cityList\\\":[506070100,506999900]}\",\"CO\":\"{\\\"countryCode\\\":\\\"CO\\\",\\\"countryName\\\":\\\"哥伦比亚\\\",\\\"countryId\\\":57,\\\"callingCode\\\":\\\"+57\\\",\\\"defaultLang\\\":\\\"es-419\\\",\\\"defaultLocale\\\":\\\"es-CO\\\",\\\"realLocale\\\":\\\"es-CO\\\",\\\"locales\\\":[\\\"es-CO\\\"],\\\"currency\\\":[\\\"COP\\\"],\\\"timezones\\\":[\\\"America/Bogota\\\"],\\\"cityList\\\":[57010100,57999900,57380100,57330100]}\",\"DO\":\"{\\\"countryCode\\\":\\\"DO\\\",\\\"countryName\\\":\\\"多米尼加\\\",\\\"countryId\\\":809,\\\"callingCode\\\":\\\"+1\\\",\\\"defaultLang\\\":\\\"es-419\\\",\\\"defaultLocale\\\":\\\"es-DO\\\",\\\"realLocale\\\":\\\"es-DO\\\",\\\"locales\\\":[\\\"es-DO\\\"],\\\"currency\\\":[\\\"DOP\\\"],\\\"timezones\\\":[\\\"America/Santo_Domingo\\\"],\\\"cityList\\\":[809230100,809190100,809999900]}\"}");

/***/ }),

/***/ "1640":
/***/ (function(module, exports, __webpack_require__) {

!function(e,o){ true?module.exports=o():undefined}(this,function(){"use strict";var e="https://as.xiaojukeji.com/ep/as/feature";var o,t,n,r,a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};Object.keys||(Object.keys=(o=Object.prototype.hasOwnProperty,t=!{toString:null}.propertyIsEnumerable("toString"),r=(n=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(e){if("function"!=typeof e&&("object"!==(void 0===e?"undefined":a(e))||null===e))throw new TypeError("Object.keys called on non-object");var s,i,c=[];for(s in e)o.call(e,s)&&c.push(s);if(t)for(i=0;i<r;i++)o.call(e,n[i])&&c.push(n[i]);return c})),Array.prototype.forEach||(Array.prototype.forEach=function(e){var o,t;if(null==this)throw new TypeError("this is null or not defined");var n=Object(this),r=n.length>>>0;if("function"!=typeof e)throw new TypeError(e+" is not a function");for(arguments.length>1&&(o=arguments[1]),t=0;t<r;){var a;t in n&&(a=n[t],e.call(o,a,t,n)),t++}});var s,i=function(){},c=[];return{getToggle:function(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i;if((o=o||{}).ns=o.ns||"service",o._t=(new Date).getTime(),o._source="jssdk",!o.name)return o.debug&&console.error("Apollo:: Not Found name"),t({code:3,data:{},message:"Apollo:: Not Found name"}),!1;if(!o.key)return o.debug&&console.error("Apollo:: Not Found key"),t({code:3,data:{},message:"Apollo:: Not Found key"}),!1;o.name&&"[object String]"===Object.prototype.toString.call(o.name)&&(o.name=[o.name]);var n=e;o.debug?n="http://astest.intra.xiaojukeji.com/ep/as/feature":!0===o.global?n="https://as.didiglobal.com/ep/as/feature":!1===o.global&&(n="https://as.xiaojukeji.com/ep/as/feature"),delete o.debug;var r=[];Object.keys(o).forEach(function(e){var t;o[e]&&("name"===e?o[e].forEach(function(o){t=encodeURIComponent(e)+"="+encodeURIComponent(o),r.push(t)}):(t=encodeURIComponent(e)+"="+encodeURIComponent(o[e]),r.push(t)))}),n+="?"+r.join("&");var a=!0,u=setTimeout(function(){a=!1,t({code:1,data:{},message:"Fetching timeout"})},o._timeout||5e3);!function(e,o){try{var t=new XMLHttpRequest;window.XDomainRequest&&(t=new window.XDomainRequest,0===window.location.href.indexOf("http://")&&0===e.indexOf("https://")&&(e=e.replace("https://","http://"))),t.open("GET",e,!0),t.onload=function(){if(t){var e=t.status,n=e>=200&&e<300||304===e,r=!("status"in t)&&t.responseText;if(n||r){var a=JSON.parse(t.responseText);o(null,a)}else o(new Error("fetch Error(status: "+e+")"));t=null}},t.onprogress=function(){},t.ontimeout=function(){},t.onerror=function(){o(new Error("Network Error")),t=null},t.send()}catch(e){window.console&&console.log(e)}}(n,function(e,n){var r={},i={code:0,data:{},message:"Success"};if(!a)return!1;clearTimeout(u),e||n.code?(i.code=2,i.message="Server response Error"):n.data.forEach(function(e){var t="",n={};e.assign&&(e.assign.args&&(n=e.assign.args),e.assign.testKey&&(t=e.assign.testKey));var a=!1,i=t.split(":").reverse();r[e.name]={isAllow:function(){if(!a&&e.allow){var n={name:e.name,testKey:t,conf:o};(function(e){s&&"function"==typeof s?s(e):c.push(e)})(n=function(e){return{apollo_testkey:e.testKey,apollo_allow:1,apollo_key:e.conf.key,apollo_ns:e.conf.ns,name:e.name}}(n)),a=!0}return e.allow},testKey:t,params:n,groupName:i.length>0?i[0]:""}}),i.data=r,t(i)})},setLogFn:function(e){s=e,c.forEach(function(e){s(e)}),c=[]},version:"1.0.5"}});


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "9613":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9613__;

/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ "a34a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("96cf");

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("a34a");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@didi/apollo-sdk-javascript/dist/apollo.min.js
var apollo_min = __webpack_require__("1640");
var apollo_min_default = /*#__PURE__*/__webpack_require__.n(apollo_min);

// CONCATENATED MODULE: ./lib/static/index.ts
/* harmony default export */ var lib_static = ({
  countryInfo: __webpack_require__("163f")
});
// CONCATENATED MODULE: ./lib/util/getLanguage.ts
/**
 * 获取locale中的language部分
 * @param locale
 * @returns
 */
function getLanguage(locale) {
  return locale ? locale.split('-')[0] : '';
}
// CONCATENATED MODULE: ./lib/util/getRegion.ts
/**
 * 获取locale中的region部分
 * @param locale
 * @returns
 */
function getRegion(locale) {
  return locale ? locale.split('-')[1] : '';
}
// CONCATENATED MODULE: ./lib/util/getTargetObject.ts
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function getTargetObject(targetObject, propsArray) {
  if (_typeof(targetObject) !== 'object' || !Array.isArray(propsArray)) {
    throw new Error('Daphne:: Function [[getTargetObject]] params type error.');
  }

  var result = {};
  Object.keys(targetObject).filter(function (key) {
    return propsArray.includes(key);
  }).forEach(function (key) {
    result[key] = targetObject[key];
  });
  return result;
}
// CONCATENATED MODULE: ./lib/util/isCountryCode.ts
/**
 * 判断是否countryCode
 * @param code
 * @returns
 */
function isCountryCode(code) {
  return /[A-Z]{2}/.test(code);
}
// EXTERNAL MODULE: external {"commonjs":"@didi/omega-tracker","commonjs2":"@didi/omega-tracker","amd":"@didi/omega-tracker","root":"Omega"}
var omega_tracker_root_Omega_ = __webpack_require__("9613");
var omega_tracker_root_Omega_default = /*#__PURE__*/__webpack_require__.n(omega_tracker_root_Omega_);

// CONCATENATED MODULE: ./lib/util/omega.ts

var IS_DEV = /^localhost|(\d+.){3}\d+/.test(window ? window.location.hostname : '');
var Omega = IS_DEV ? {
  trackEvent: function trackEvent() {
    console.log('daphneSDK：测试环境屏蔽埋点');
  }
} : omega_tracker_root_Omega_default.a.getTracker({
  appKey: 'omega3323f005b6',
  autoPosition: false,
  uploadHost: 'omgup.didiglobal.com',
  browserRouterEnable: true,
  autoClick: false,
  attrs: {
    // 设备和业务信息 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=272905834
    osType: -1,
    businessType: 5,
    brand: 2,
    terminalType: 5 // 端类型信息 1：独立端 5：web

  }
});
// CONCATENATED MODULE: ./lib/util/index.ts





// CONCATENATED MODULE: ./lib/index.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




var CUSTOM_NAME_REG = /^_ns_.*?_name_.*?_key_.*?_phone_.*?$/;
var daphne = {
  apolloEnv: {},
  commonToggle: {
    countryInfo: ''
  },
  customToggleCache: [],
  init: function init(opts) {
    return _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var apolloOpts, parseCommonConfig;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              daphne.apolloEnv = opts || {};
              apolloOpts = _objectSpread({
                ns: 'sailing_common_lda_fe',
                name: ['country_info'],
                key: 'user_key'
              }, daphne.apolloEnv);

              parseCommonConfig = function parseCommonConfig(value) {
                var result = {};

                for (var key in value) {
                  result[key] = JSON.parse(value[key]);
                }

                return result;
              };

              if (!daphne.commonToggle.countryInfo) {
                _context.next = 6;
                break;
              }

              console.warn('Daphne:: already init ！ return ');
              return _context.abrupt("return", Promise.resolve(daphne._cloneDeep(daphne.commonToggle)));

            case 6:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var startTime = new Date().getTime();
                apollo_min_default.a.getToggle(apolloOpts, function (result) {
                  try {
                    var endTime = new Date().getTime();

                    if (!result.code) {
                      daphne.commonToggle.countryInfo = parseCommonConfig(result.data.country_info.params);
                      resolve(daphne._cloneDeep(daphne.commonToggle));
                      Omega.trackEvent('sailing_daphnesdk_init_success_bt', '获取参数成功', {
                        startTime: startTime,
                        time: endTime - startTime
                      });
                    } else {
                      daphne.commonToggle.countryInfo = parseCommonConfig(lib_static.countryInfo);
                      resolve(daphne._cloneDeep(daphne.commonToggle));
                      console.warn('Daphne:: Apollo getToggle Error! getDefaultConfig');
                      Omega.trackEvent('sailing_daphnesdk_init_error_default_logic_bt', '获取参数失败走兜底逻辑', {
                        apolloOpts: apolloOpts,
                        result: result,
                        startTime: startTime,
                        time: endTime - startTime
                      });
                    }
                  } catch (e) {
                    reject(e);
                    console.error('Daphne:: init Error!');
                    console.error(e);
                    Omega.trackEvent('sailing_daphnesdk_init_error_bt', 'init 代码逻辑异常', {
                      apolloOpts: apolloOpts,
                      error: e
                    });
                  }
                });
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getToggle: function getToggle(opts) {
    return _asyncToGenerator( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var apolloOpts;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              apolloOpts = _objectSpread(_objectSpread({}, daphne.apolloEnv), opts);
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var startTime = new Date().getTime();
                apollo_min_default.a.getToggle(apolloOpts, function (result) {
                  try {
                    var endTime = new Date().getTime();

                    if (!result.code) {
                      var customName = daphne._getCustomName(apolloOpts);

                      daphne.customToggleCache[customName] = _objectSpread(_objectSpread({}, result), {}, {
                        _customName: customName
                      });
                      resolve(daphne._cloneDeep(daphne.customToggleCache[customName]));
                      Omega.trackEvent('sailing_daphnesdk_gettoggle_success_bt', '获取自定义配置成功', {
                        startTime: startTime,
                        time: endTime - startTime
                      });
                    } else {
                      reject(result);
                      console.error('Daphne:: Apollo Error! Code: ' + result.code + ', ' + result.message);
                      Omega.trackEvent('sailing_daphnesdk_gettoggle_http_error_bt', '获取自定义配置失败', {
                        apolloOpts: apolloOpts,
                        result: result,
                        startTime: startTime,
                        time: endTime - startTime
                      });
                    }
                  } catch (e) {
                    reject(e);
                    console.error('Daphne:: getToggle Error!');
                    console.error(e);
                    Omega.trackEvent('sailing_daphnesdk_gettoggle_code_error_bt', 'getToggle 代码逻辑异常', {
                      apolloOpts: apolloOpts,
                      error: e
                    });
                  }
                });
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getToggleByCache: function getToggleByCache(config) {
    var customName;

    if (typeof config === 'string') {
      if (CUSTOM_NAME_REG.test(config)) {
        customName = config;
      } else {
        throw new Error('Daphne:: config is not _customName');
      }
    } else {
      customName = daphne._getCustomName(config);
    }

    return daphne._cloneDeep(daphne.customToggleCache[customName]);
  },
  getCountryCodeList: function getCountryCodeList() {
    var list = daphne.commonToggle.countryInfo.list;
    return list;
  },
  getCountryNameList: function getCountryNameList() {
    return daphne._getListByKey('countryName');
  },
  getCurrencyList: function getCurrencyList() {
    return daphne._getListByKey('currency');
  },
  getLocaleList: function getLocaleList() {
    return daphne._getListByKey('realLocale');
  },
  getLangList: function getLangList() {
    return daphne._getListByKey('defaultLang');
  },
  getCallingCodeList: function getCallingCodeList() {
    return daphne._getListByKey('callingCode');
  },
  getCountryName: function getCountryName(country) {
    return daphne._getItemByKeyAndCounty('countryName', country);
  },
  getLang: function getLang(country) {
    return daphne._getItemByKeyAndCounty('defaultLang', country);
  },
  getCallingCode: function getCallingCode(country) {
    return daphne._getItemByKeyAndCounty('callingCode', country);
  },
  getCurrency: function getCurrency(country) {
    return daphne._getItemByKeyAndCounty('currency', country)[0];
  },
  // 克隆简单实现 防止用户直接修改数据
  _cloneDeep: function _cloneDeep(data) {
    return JSON.parse(JSON.stringify(data));
  },
  _getCustomName: function _getCustomName(_ref) {
    var _ref$ns = _ref.ns,
        ns = _ref$ns === void 0 ? '' : _ref$ns,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? '' : _ref$name,
        _ref$key = _ref.key,
        key = _ref$key === void 0 ? '' : _ref$key,
        _ref$phone = _ref.phone,
        phone = _ref$phone === void 0 ? '' : _ref$phone;
    name = typeof name === 'string' ? name : name.join(',');
    return "_ns_".concat(ns, "_name_").concat(name, "_key_").concat(key, "_phone_").concat(phone);
  },
  _getListByKey: function _getListByKey(key) {
    var countryInfo = daphne.commonToggle.countryInfo;
    var result = {};

    for (var k in countryInfo) {
      if (isCountryCode(k)) {
        result[k] = countryInfo[k][key];
      }
    }

    return result;
  },
  _getItemByKeyAndCounty: function _getItemByKeyAndCounty(key, country) {
    var countryInfo = daphne.commonToggle.countryInfo;
    return countryInfo[country][key];
  }
};
/* harmony default export */ var lib = (daphne);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (lib);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=index.umd.js.map